var _rect, _rect2, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint0_linear_7_57209)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_57209",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_57209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 25.5C11.7083 25.5 11.3158 25.3369 10.9892 25.0108C10.6631 24.6841 10.5 24.2916 10.5 23.8333V12.1666C10.5 11.7083 10.6631 11.3158 10.9892 10.9891C11.3158 10.663 11.7083 10.5 12.1667 10.5H15.6667C15.8472 9.99998 16.1494 9.5972 16.5733 9.29165C16.9967 8.98609 17.4722 8.83331 18 8.83331C18.5278 8.83331 19.0036 8.98609 19.4275 9.29165C19.8508 9.5972 20.1528 9.99998 20.3333 10.5H23.8333C24.2917 10.5 24.6842 10.663 25.0108 10.9891C25.3369 11.3158 25.5 11.7083 25.5 12.1666V23.8333C25.5 24.2916 25.3369 24.6841 25.0108 25.0108C24.6842 25.3369 24.2917 25.5 23.8333 25.5H12.1667ZM13.8333 22.1666H19.6667V20.5H13.8333V22.1666ZM13.8333 18.8333H22.1667V17.1666H13.8333V18.8333ZM13.8333 15.5H22.1667V13.8333H13.8333V15.5ZM18 11.5416C18.1806 11.5416 18.33 11.4825 18.4483 11.3641C18.5661 11.2464 18.625 11.0972 18.625 10.9166C18.625 10.7361 18.5661 10.5866 18.4483 10.4683C18.33 10.3505 18.1806 10.2916 18 10.2916C17.8194 10.2916 17.6703 10.3505 17.5525 10.4683C17.4342 10.5866 17.375 10.7361 17.375 10.9166C17.375 11.0972 17.4342 11.2464 17.5525 11.3641C17.6703 11.4825 17.8194 11.5416 18 11.5416Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_57209",
    x1: 53.5,
    y1: 56,
    x2: 15.5455,
    y2: -11.4545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6BC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#7986CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5CAE9"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.afc957ccb5100b3cb9be032517550e10.svg";
export { ForwardRef as ReactComponent };